export default "__VITE_ASSET__CtPh2yWF__"